import React, { useEffect } from 'react';
import './pages.scss'
import PageRoute from './pages.route';
import SideBarComponent from '../shared/components/sidebar/sideBar';
import HeaderComponent from '../shared/components/header/header';
import { connect } from 'react-redux';
import ThemeService from '../services/theme-services';

const themeService = new ThemeService();


const PagesComponent = (props: any) => {

    const [openMenu, setOpenMenu] = React.useState<any>(true);

    useEffect(() => {
        themeService.initializeTheme();
    }, [])


    useEffect(() => {
        detectMobileView();
    }, []);

    const isOpenMenu = (value: any) => {
        setOpenMenu(value)
    }

    const detectMobileView = () => {
        if (window.innerWidth <= 767) {
            setOpenMenu(false)
        } else {
            setOpenMenu(true);
        }
    }
    return (
        <div className="main-view">
            <HeaderComponent className='layout-header' openMenu={openMenu} onClick={isOpenMenu} />
            <div className="dx-theme-background-color main-content">
                <div className="sidebar-cover">
                     <SideBarComponent openMenu={openMenu} />
                </div>
                <div className={`dashboard-cover dx-theme-background-color ${!openMenu ? "hide-sidebar" : ""}`}>
                    {PageRoute(props)}
                </div>
            </div>
        </div>
    );
}


const mapStateToProps = (state: any) => {
    return {
        isLoaderShow: state.appLoaderReducer.isLoaderShow,
        isShowSideBar: state.appSidebarReducer
    }
}

export default connect(mapStateToProps)(PagesComponent);